import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const cancelSupportV2Wipe = {
  name: "cancelSupportV2Wipe" as const,
  input: z.object({
    teamId: zExt.objectId(),
    workflowId: z.string().optional(),
  }),
  output: z.object({ status: z.literal("cancelled"), workflowId: z.string() }),
};
